module.exports = __webpack_public_path__ + "files/68f27ab24b1e2bfd35289a54f05a634b.png";